import React, { useState, useEffect } from 'react';
import Button from '../common/Button/Button';
import InputField from '../common/InputField/InputField';
import { Customer } from '../../types/customerTypes';
import styles from './CustomerForm.module.scss';

interface CustomerFormProps {
  customer?: Customer;
  onSubmit: (customer: Customer) => void;
  onCancel: () => void;
  loading?: boolean;
}

const CustomerForm: React.FC<CustomerFormProps> = ({
  customer,
  onSubmit,
  onCancel,
  loading = false
}) => {
  const [formData, setFormData] = useState<Partial<Customer>>({
    name: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    state: '',
    pwd: '',
    zip_code: '',
    is_des: false,
    country: 'India',
    is_active: true,
    is_old_url: '',
  });

  useEffect(() => {
    if (customer) {
      setFormData(customer);
    }
  }, [customer]);

  const handleInputChange = (field: keyof Customer, value: any) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData as Customer);
  };

  return (
    <form onSubmit={handleSubmit} className={styles.customerForm}>
      <div className={styles.formGrid}>
        <div className={styles.formSection}>
          <h3>Customer Information</h3>
          <div className={styles.formRow}>
            <InputField
              type="text"
              name="name"
              label="Full Name"
              value={formData.name || ''}
              onChange={(e) => handleInputChange('name', e.target.value)}
              required
            />
            <InputField
              type="email"
              name="email"
              label="Email Address"
              value={formData.email || ''}
              onChange={(e) => handleInputChange('email', e.target.value)}
            />
          </div>
          <div className={styles.formRow}>
            <InputField
              type="tel"
              name="phone"
              label="Phone Number"
              value={formData.phone || ''}
              onChange={(e) => handleInputChange('phone', e.target.value)}
              required
            />
            <div className={styles.selectWrapper}>
              <label htmlFor="isActive">Status</label>
              <select
                id="isActive"
                value={formData.is_active ? 'true' : 'false'}
                onChange={(e) => handleInputChange('is_active', e.target.value === 'true')}
                className={styles.select}
              >
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </select>
            </div>
          </div>
          <div className={styles.formRow}>
            <InputField
              type="text"
              name="pwd"
              label="Password"
              value={formData.pwd || ''}
              onChange={(e) => handleInputChange('pwd', e.target.value)}
            />
            <div className={styles.selectWrapper}>
              
            </div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h3>Address Information</h3>
          <div className={styles.formRow}>
            <InputField
              type="text"
              name="address"
              label="Street Address"
              value={formData.address || ''}
              onChange={(e) => handleInputChange('address', e.target.value)}
              required
            />
          </div>
          <div className={styles.formRow}>
            <InputField
              type="text"
              name="city"
              label="City"
              value={formData.city || ''}
              onChange={(e) => handleInputChange('city', e.target.value)}
              required
            />
            <InputField
              type="text"
              name="state"
              label="State"
              value={formData.state || ''}
              onChange={(e) => handleInputChange('state', e.target.value)}
              required
            />
          </div>
          <div className={styles.formRow}>
            <InputField
              type="text"
              name="zipCode"
              label="ZIP Code"
              value={formData.zip_code || ''}
              onChange={(e) => handleInputChange('zip_code', e.target.value)}
              required
            />
            <InputField
              type="text"
              name="country"
              label="Country"
              value={formData.country || 'India'}
              onChange={(e) => handleInputChange('country', e.target.value)}
              required
            />
          </div>
        </div>
      </div>

      <div className={styles.section}>
          <h3>Customer Balance URL</h3>
          <div className={styles.fieldGroup}>
            <InputField
              label="PDF URL"
              type="text"
              name="is_old_url"
              value={formData.is_old_url || ''}
              onChange={(e) => handleInputChange('is_old_url', e.target.value)}
              placeholder="Enter balance URL"
              // error={errors.is_old_url}
            />
          </div>
        </div>

      {/* <div className={styles.toggleRow}>
          <label className={styles.toggleLabel}>
              <span>Show Description</span>
              <label className={styles.toggleSwitch}>
                <input
                  type="checkbox"
                  checked={formData.is_des}
                  onChange={e => setFormData({ ...formData, is_des: e.target.checked })}
                />
                <span className={styles.slider}></span>
              </label>
            </label>
            </div> */}

      <div className={styles.formActions}>
        <Button
          type="button"
          variant="secondary"
          onClick={onCancel}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="primary"
          disabled={loading}
        >
          {loading ? 'Saving...' : (customer ? 'Update Customer' : 'Create Customer')}
        </Button>
      </div>
    </form>
  );
};

export default CustomerForm; 
